import { ChangeDetectionStrategy, Component, ElementRef, Input, signal, ViewChild, WritableSignal } from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-twitter-logo-svg",
  standalone: true,
  templateUrl: "./twitter-logo.svg",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwitterLogoSvgComponent {
  @Input() fill: string = "white";
  @Input() height: string = "auto";
  @Input() width: string = "auto";

  svgContent: WritableSignal<SafeHtml> = signal(undefined);

  @ViewChild("div") div: ElementRef;
}
